import { render } from "./EventsModal.vue?vue&type=template&id=e8c68270&ts=true"
import script from "./EventsModal.vue?vue&type=script&lang=ts"
export * from "./EventsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Events/EventsModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e8c68270"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e8c68270', __exports__)) {
    api.reload('e8c68270', __exports__)
  }
  
  module.hot.accept("./EventsModal.vue?vue&type=template&id=e8c68270&ts=true", () => {
    api.rerender('e8c68270', render)
  })

}


export default __exports__